import { fetch } from "utils/dataAccess";
import { setOrganization } from "utils/dataAccessOrganizationHandler";
import normalizeTranslations from "../translations";

export function error(error) {
    return { type: "CATEGORY_CREATE_ERROR", error };
}

export function loading(loading) {
    return { type: "CATEGORY_CREATE_LOADING", loading };
}

export function success(created) {
    return { type: "CATEGORY_CREATE_SUCCESS", created };
}

export function create(values) {
    setOrganization(values);

    return dispatch => {
        dispatch(loading(true));

        values = normalizeTranslations(values);

        return fetch("/categories", {method: "POST", body: JSON.stringify(values)})
            .then(response => {
                dispatch(loading(false));

                return response.json();
            })
            .then(retrieved => dispatch(success(retrieved)))
            .catch(e => {
                dispatch(loading(false));
                dispatch(error(e));
            });
    };
}

export function reset() {
    return dispatch => {
        dispatch({type: "CATEGORY_CREATE_RESET"});
        dispatch(loading(false));
        dispatch(error(null));
        dispatch(success(null))
    };
}
